import React, { useCallback } from "react";
import { StoryblokBlockComponent } from "../../lib/storyblok/types/StoryblokComponent";
import PreambleUi from "../../ui/Preamble";
import { PreambleBlock } from "../../lib/storyblok/types/blocks/PreambleBlock";
import { useLinks } from "../../lib/storyblok/useLinks";
import Button from "../../ui/Button";

const Preamble: StoryblokBlockComponent<PreambleBlock> = ({
  title,
  text,
  featured,
  titleType,
  noTopPadding,
  noBottomPadding,
  innerSpacing,
  contentAlignment,
  buttons,
}) => {
  const resolveLink = useLinks();

  const renderButtons = useCallback(
    () =>
      buttons?.map((button) => (
        <Button
          variant={button.buttonType || "default"}
          key={button._uid}
          href={button.buttonLink ? resolveLink(button.buttonLink) : ""}
        >
          {button.buttonText}
        </Button>
      )),
    [buttons, resolveLink]
  );

  return (
    <PreambleUi
      title={title}
      labelAs={titleType || "h2"}
      text={text}
      noTopPadding={noTopPadding}
      noBottomPadding={noBottomPadding}
      innerSpacing={innerSpacing}
      contentAlignment={contentAlignment}
      buttons={renderButtons()}
      featured={featured}
    />
  );
};

export default Preamble;
